import { render, staticRenderFns } from "./InfoBar.vue?vue&type=template&id=73cc6ce6&scoped=true&"
import script from "./InfoBar.vue?vue&type=script&lang=ts&"
export * from "./InfoBar.vue?vue&type=script&lang=ts&"
import style0 from "./InfoBar.vue?vue&type=style&index=0&id=73cc6ce6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73cc6ce6",
  null
  
)

export default component.exports